export default __webpack_public_path__ + "static/media/oasis-family-3.720787fe.png";